import { MissionKindEnum } from '@e-socna/data-layer';
import type { Id, MissionWorkflowCategoryEnum } from '@e-socna/data-layer';

import { filterMissionWorkflowsOfKind } from './mission-workflows-of-kind.util';

type Family = Readonly<{
  isSelectedByDefault: boolean;
  missionWorkflowIds: readonly Id[];
}>;

// A mission keeps the workflows of its family; a mission without workflow yet
// starts in the default family.
export const findMissionWorkflowFamily = <F extends Family>(
  families: readonly F[],
  missionWorkflowId: Id,
): F | undefined =>
  families.find((family) =>
    family.missionWorkflowIds.includes(missionWorkflowId),
  ) ?? families.find((family) => family.isSelectedByDefault);

export const filterMissionWorkflowsOfFamily = <W extends Readonly<{ _id: Id }>>(
  workflows: readonly W[],
  family: Family | undefined,
): readonly W[] =>
  workflows.filter((workflow) =>
    family?.missionWorkflowIds.includes(workflow._id),
  );

// A mission joins a collaboration only when its family has the workflows of
// a collaboration and of its sub-missions.
export const hasCollaborationWorkflows = (
  familyWorkflows: readonly Readonly<{
    category: MissionWorkflowCategoryEnum;
  }>[],
): boolean =>
  [MissionKindEnum.Composite, MissionKindEnum.SubMission].every(
    (kind) => filterMissionWorkflowsOfKind(familyWorkflows, kind).length > 0,
  );
